<template>
  <div>
    <div class="navBar">
      <div class="contentLogoAndTitle">
        <div>
          <img style="width: 140px; height: 45px" :src="logoOmega" />
        </div>
      </div>
    </div>

    <div
      :class="`sidebar ${disable}`"
      @mouseenter="sidBarExpand"
      @mouseleave="sidBarExpand"
    >
      <ul class="nav-links">
        <li style="margin-top: 20px">
          <router-link to="/home">
            <button
              id="selected"
              :class="`${iconsCenter} contentLink iconHome ${
                navItemSelected === 'home' ? 'activeNavItems' : ''
              }`"
            >
              <i> <b-icon-house-door scale="1.3"></b-icon-house-door></i>
              <span :class="sizeText">Início</span>
            </button>
          </router-link>
        </li>

        <li>
          <router-link to="/alunos">
            <button
              id="selected"
              :class="`${iconsCenter} contentLink iconHome ${
                navItemSelected === 'alunos' ? 'activeNavItems' : ''
              }`"
            >
              <i> <img class="teach" :src="student" /> </i>
              <span :class="sizeText">Alunos</span>
            </button>
          </router-link>
        </li>

        <li>
          <router-link to="/cursos">
            <button
              id="selected"
              :class="`${iconsCenter} contentLink iconHome ${
                navItemSelected === 'cursos' ? 'activeNavItems' : ''
              }`"
            >
              <i> <img class="teach" :src="certified" /> </i>
              <span :class="sizeText">Cursos</span>
            </button>
          </router-link>
        </li>
        <li>
          <router-link to="/usuarios">
            <button
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'usuarios' ? 'activeNavItems' : ''
              }`"
            >
              <i> <img class="teach" :src="contacts" /> </i>
              <span :class="sizeText">Usuários</span>
            </button>
          </router-link>
        </li>
        <li>
          <router-link to="/matricula">
            <button
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'matricula' ? 'activeNavItems' : ''
              }`"
            >
              <i>
                <img class="teach" :src="library" />
              </i>
              <span :class="sizeText">Gerenciar Matrículas</span>
            </button>
          </router-link>
        </li>
        <li>
          <router-link to="/contrato">
            <button
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'contrato' ? 'activeNavItems' : ''
              }`"
            >
              <i> <img class="teach" :src="register" /> </i>
              <span :class="sizeText">Vincular Contrato</span>
            </button>
          </router-link>
        </li>
        <li>
          <router-link to="/financeiro">
            <button
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'financeiro' ? 'activeNavItems' : ''
              }`"
            >
              <i> <img class="teach" :src="payment" /> </i>
              <span :class="sizeText">Financeiro</span>
            </button>
          </router-link>
        </li>
      </ul>

      <div class="containerBtnSair">
        <ul class="nav-links">
          <li>
            <router-link to="/">
              <button @click="exit" :class="`${iconsCenter} contentLink`">
                <i> <img class="teach" :src="doors" /> </i>
                <span :class="btnSair">Sair</span>
              </button>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <button class="containerMobile" @click="sidBarMobileExpand">
      <b-icon-list-nested v-if="collapsedMobile" scale="2" />
      <b-icon-x v-else scale="2" />
    </button>

    <div :class="`${alternClassMobile} sideMobile`">
      <ul class="nav-links">
        <li>
          <router-link to="/home">
            <button
              style="margin-top: 20px"
              id="selected"
              @click="sidBarMobileExpand"
              :class="`${iconsCenter} contentLink iconHome ${
                navItemSelected === 'home' ? 'activeNavItems' : ''
              }`"
            >
              <i> <b-icon-house-door scale="1.3"></b-icon-house-door></i>
              <span :class="sizeText">Início</span>
            </button>
          </router-link>
        </li>

        <li>
          <router-link to="/cursos">
            <button
              id="selected"
              @click="sidBarMobileExpand"
              :class="`${iconsCenter} contentLink iconHome ${
                navItemSelected === 'cursos' ? 'activeNavItems' : ''
              }`"
            >
              <i> <b-icon-person scale="1.3"></b-icon-person></i>
              <span :class="sizeText">Cursos</span>
            </button>
          </router-link>
        </li>
        <li>
          <router-link to="/usuarios">
            <button
              @click="sidBarMobileExpand"
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'usuarios' ? 'activeNavItems' : ''
              }`"
            >
              <i>
                <b-icon-person-lines-fill scale="1.3"></b-icon-person-lines-fill
              ></i>
              <span :class="sizeText">Usuários</span>
            </button>
          </router-link>
        </li>
        <li>
          <router-link to="/financeiro">
            <button
              @click="sidBarMobileExpand"
              :class="`${iconsCenter} contentLink ${
                navItemSelected === 'financeiro' ? 'activeNavItems' : ''
              }`"
            >
              <i> <img class="teach" :src="payment" /> </i>
              <span :class="sizeText">Financeiro</span>
            </button>
          </router-link>
        </li>
      </ul>

      <div class="containerBtnSair">
        <ul class="nav-links">
          <li>
            <router-link to="/">
              <button @click="exit" :class="`${iconsCenter} contentLink`">
                <i> <b-icon-door-open scale="1.3"></b-icon-door-open></i>
                <span :class="btnSair">Sair</span>
              </button>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import logoOmega from "../../assets/omegaBlue.png";
import logo from "../../assets/logoOmega.png";
import teach from "../../assets/studying.svg";
import certified from "../../assets/certified.svg";
import student from "../../assets/student.svg";
import contacts from "../../assets/contacts.svg";
import register from "../../assets/register.svg";
import doors from "../../assets/exit.svg";
import library from "../../assets/library.svg";
import money from "../../assets/money.svg";
import payment from "../../assets/payment.svg";

import { clearTokens } from "../../utils/clearTokens";

export default {
  data() {
    return {
      logoOmega: logoOmega,
      teach: teach,
      certified: certified,
      register: register,
      student: student,
      doors: doors,
      library: library,
      money: money,
      payment: payment,
      contacts: contacts,
      logo: logo,
      colapse: true,
      collapsed: true,
      collapsedMobile: true,
      disable: "",
      alternClassMobile: "disableMobile",
      sizeText: "link_name",
      iconsCenter: "btnsGerais",
      btnSair: "btnSair",
      sideOCompany: "sideCompanyDisable",
      contentSideOCompany: "disabledContent",
      companies: [],
      tokenCompanySelected: null,
    };
  },
  methods: {
    sidBarExpand() {
      this.disable = this.disable !== "disable" ? "disable" : "";
      this.colapse = !this.colapse;
      this.sizeText = this.colapse ? "link_name" : "link_nameTwo";
      this.iconsCenter = this.colapse ? "btnsGerais" : "btnsGeraisTwo";
      this.btnSair = this.colapse ? "btnSair" : "btnSairTwo";
      if (this.colapse) this.$store.commit("REGISTER_WIDTH", "80%");
      else this.$store.commit("REGISTER_WIDTH", "90%");
    },
    sidBarMobileExpand() {
      this.collapsedMobile = !this.collapsedMobile;

      this.alternClassMobile =
        this.alternClassMobile !== "sidebarMobile"
          ? "sidebarMobile"
          : "disableMobile";
      this.sizeText = this.collapsedMobile ? "link_name" : "link_nameTwo";
      this.iconsCenter = this.collapsedMobile ? "btnsGerais" : "btnsGeraisTwo";
      this.btnSair = this.collapsedMobile ? "btnSair" : "btnSairTwo";
    },
    sideOpenCompany() {
      this.collapsed = !this.collapsed;
      this.sideOCompany = this.collapsed ? "sideCompany" : "sideCompanyDisable";
      this.contentSideOCompany = this.collapsed ? "" : "disabledContent";
      this.isSideCommonOpen = !this.isSideCommonOpen;
    },

    handleClickOutside(event) {
      const sideCommonElement = this.$el.querySelector(".sideCompany");

      if (
        sideCommonElement &&
        !sideCommonElement.contains(event.target) &&
        !event.target.classList.contains("buttonToOpenSideCommon")
      ) {
        this.isSideCommonOpen = false;
        this.collapsed = false;
        this.sideOCompany = "sideCompanyDisable";
        this.contentSideOCompany = "";
      }
    },

    sideOpenAdnFindUser() {
      this.sideOpenCompany();
      this.handleFindUser();
    },
    exit() {
      clearTokens();
    },

    handleTokenList() {
      const tokens = JSON.parse(localStorage.getItem("tokenList"));
      const token = localStorage.getItem("token");
      if (tokens && tokens.length) {
        this.companies = tokens;
        const companySelected = tokens.find((item) => item.token === token);
        this.$nextTick(() => {
          this.tokenCompanySelected = companySelected.token;
          this.$refs.companies.valueItems = companySelected.token;
        });
      }
    },
  },
  computed: {
    ...mapState([
      "navItemSelected",
      "dataCompany",
      "numberOfNewMessages",
      "dataPlan",
    ]),
    handleVerifyUserIsAccountant() {
      const userLevel = localStorage.getItem("userLevel");
      if (userLevel === "accountant") {
        return true;
      } else {
        return false;
      }
    },
    enableSelectCompany() {
      const tokens = localStorage.getItem("tokenList");
      if (tokens && tokens.length) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.sidBarExpand();
    this.handleTokenList();
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: sans-serif;
}

.teach {
  width: 40px;
  height: 25px;
}

@import url("https://fonts.googleapis.com/css?family=Poppins:500,500,500");

.sidebar {
  position: fixed !important;
  z-index: 1000;
  top: 50px;
  height: 100vh;
  max-height: calc(100vh - 50px);
  width: 260px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #0188c8;
  transition: all 0.5s ease;
  overflow-y: overlay;
  padding: 0 6px;
  overflow-x: hidden;
}

.disable {
  position: fixed !important;
  z-index: 1000;
  top: 50px;
  height: calc(100vh - 50px);
  width: 70px;
  background: #0188c8;
  transition: all 0.5s ease;
  padding: 0 6px;
}

.disableMobile {
  display: none;
}

.sideMobile {
  display: none;
}

.sidebarMobile {
  display: none;
}

.sidebar .nav-links li {
  height: 40px;
  width: 100%;
  list-style: none;
}

.nav-links {
  gap: 5px;
  display: flex;
  flex-direction: column;
}

.sidebar .nav-links li .contentLink {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: all 0.4s ease;
  background: #027db7;
}

.sidebar .nav-links li .contentLink:hover {
  background: #3c6eca;
}

.sidebar .nav-links li .contentLink i {
  min-width: 55px;
  text-align: center;
  color: #fff;
  font-size: 14px;
}

.sidebar .nav-links li .contentLink .link_name {
  color: #fff;
  font-size: 15px;
  transition: all 0.4s ease;
}

.sidebar .nav-links li .contentLink .link_nameTwo {
  color: #fff;
  font-size: 0px;
  display: none;
  transition: all 0.4s ease;
}

.sidebar .nav-links li .contentLink .droperText {
  color: #fff;
  font-size: 12px;
  transition: all 0.4s ease;
}

li a {
  margin-top: 5px;
  text-decoration: none !important;
}

ul {
  margin-bottom: 0 !important;
}

#logoEmpresaTwo {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: contain;
  transition: all 0.4s ease;
}

.nomeEmpresaText {
  font-size: 28px;
  transition: all 0.4s ease;
}

.nomeEmpresaTextTwo {
  font-size: 0px;
  transition: all 0.4s ease;
}

.containerBtnSair {
  /* position: absolute; */
  /* bottom: 70px; */
  width: 100%;
  color: #0188c8;
  background: white;
}

.btnSair {
  bottom: 0;
  color: white;
  font-size: 14px;
  transition: all 0.4s ease;
}

.btnSairTwo {
  display: none;
  bottom: 0;
  color: white;
  font-size: 0px;
  transition: all 0.4s ease;
}

.iconLogo {
  width: 100%;
  font-size: 40px;
  color: white;
  border: none;
}

span {
  cursor: pointer;
}

.iconEffect {
  display: none !important;
}

.iconEffect:focus i {
  background-color: #dcdcdc50 !important;
  transform: rotate(180deg) !important;
}

.spin {
  height: 20px;
  width: 20px;
  color: gray;
}

.userContent {
  display: flex;
  text-transform: capitalize;
}

.activeNavItems {
  background-color: #0188c8 !important;
}

.btnsGeraisTwo {
  justify-content: center !important;
  outline: none !important;
  border: none !important;
  color: white;
}

.btnsGerais {
  outline: none !important;
  border: none !important;
}

button {
  background-color: transparent;
  padding: 5px;
}

.navBar {
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 50px;
  background-color: white;
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-shadow: 0px 0px 3px 0px rgb(106, 102, 102);
}

.contentLogoAndTitle {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 100px;
  font-size: 22px;
}

.contentHelp {
  position: relative;
  background-color: #eeeeee;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.357);
  padding: 2px;
  border-radius: 3px;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  z-index: 2;
}

.contentHelp:hover {
  background-color: #c9c9c9;
}

.contentHelp div {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.iconHelper {
  width: 70px;
  height: 29px;
  color: #0188c8;
  z-index: 1000;
  padding: 0.3rem 20px;
}

.sideCompany {
  display: flex;
  position: absolute;
  width: 280px;
  height: 70vh;
  background: white;
  right: 10px;
  top: 60px;
  border: none;
  border-radius: 5px;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
  gap: 15px;
  box-shadow: 0px 1px 4px 1px rgba(142, 142, 142, 0.78);
  /* animation: example 3s; */
}

.sideCommon {
  transition: ease-in all 0.3s;
  /* animation: example 3s; */
}

.sideCompanyDisable {
  height: 0;
  visibility: hidden;
  display: none;
}

.disabledContent {
  height: 0;
  visibility: hidden;
  /* animation: example 3s; */
}

@keyframes example {
  from {
    visibility: hidden;
  }
  to {
    visibility: visible;
  }
}

.closeSize {
  color: rgb(134, 134, 134);
  display: flex;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  position: absolute;
  left: 10px;
  top: 5px;
}

.logoSide {
  width: 120px;
  height: 80px;
}

.btnModal-contract {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  justify-content: space-around;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #00486e;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #00486e;
}

.btnContentPlan {
  font-size: 11px;
  border: 1px solid #00486e;
  border-radius: 5px;
  height: 30px;
  position: relative;
  color: #ffffff;
  background: #0188c8;
  padding: 7px 15px;
}

.contentContract {
  height: 85vh;
  position: relative;
}

.titleContract {
  font-size: 20px;
  text-align: center;
  color: #0188c8;
  font-weight: bold;
}

.textContract {
  text-align: justify;
  font-size: 12px;
  height: 70vh;
  max-height: 70vh;
  overflow: auto;
  padding: 0 50px;
}

.closeModal {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgb(238, 238, 238);
  padding: 2px 3px;
  border-radius: 4px;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}

.contentContractPlan {
  height: auto;
}

.bodyPlan {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
}

.myPlan {
  display: flex;
  flex-direction: column;
  border: 2px solid #eeeeee;
  border-radius: 6px;
  padding: 13px;
  justify-content: space-between;
}

.myPlanTitle {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 3px solid #0188c8;
  padding: 20px;
}

.myPlanTitle span {
  font-size: 14px;
  font-weight: bold;
}

.imgMyPlan {
  width: 170px;
  height: 70px;
}

.myPlanDescription {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 35%;
}

.myPlanDescriptionItem {
  font-size: 12px;
  font-style: italic;
  color: rgb(137 137 137);
  gap: 8px;
  display: flex;
  align-items: center;
}

.myPlanDescriptionItemIcon {
  color: #48b865;
}

.myPlanAlter {
  display: flex;
  align-items: flex-end;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 0 0;
}

.containerRadio label {
  display: flex;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  margin-bottom: 0.375em;
}

.containerRadio label input {
  position: absolute;
  left: -9999px;
}

.containerRadio label input:checked + span {
  background-color: #f3f2f2;
  color: #0188c8;
  font-weight: bold;
}

.containerRadio label input:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em #00486e;
}

.containerRadio label span {
  display: flex;
  align-items: center;
  color: #0188c8;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 2px;
  transition: 0.25s ease;
}

.containerRadio label span:hover {
  background-color: #e6e6e6;
}

.containerRadio label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  margin-right: 0.375em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.1em #00486e;
}

.headerSide {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 15px 0 10px 0;
  gap: 6px;
  border-bottom: 2px solid #c3c3c3;
}

.contentSide {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 5px;
}

.contentSideDown {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: absolute;
  bottom: 10px;
  gap: 5px;
}

.contentSideBtn {
  border: none;
  border-radius: 3px;
  font-size: 13px;
  color: #403b74;
  padding: 5px 20px;
  width: 100%;
}

.contentSideBtn:hover {
  background: rgb(219, 219, 219);
}

.btnExitIsAccountant {
  color: white;
  padding: 7px;
  background-color: rgb(62, 102, 174);
  width: 70px;
  border-radius: 5px;
  text-align: center;
  letter-spacing: 0.1rem;
  transition: ease-in all 0.1s;
  font-weight: 500 !important;
}

.btnExitIsAccountant:hover {
  background-color: rgb(52, 85, 145);
  transition: ease-in all 0.1s;
}

.nameCompany {
  color: #313b42;
  font-size: 16px;
}

.nameCompany span {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.contentSelectCompany {
  width: 25%;
  color: #313b42;
  font-size: 16px;
}

.contentSelectCompany span {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.textAccountant {
  color: #313b42;
  font-size: 18px;
}

.textAccountant span {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.contentHelpAndNotificationAccounting {
  display: flex;
  gap: 2rem;
  align-items: center;
}

.contentHelpAndNotificationAccounting a {
  text-decoration: none;
  outline: none;
  color: #313b42;
}

.contentHelpAndNotificationAccounting a:hover {
  text-decoration: none;
  outline: none;
  color: black;
}

.contentNotificationAccounting {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  padding: 0.3rem;
  border-radius: 3px;
  text-align: center;
  cursor: pointer;
  transition: ease-in all 0.1s;
}

.contentNotificationAccounting:hover {
  background-color: #c9c9c9;
}

.scrollTrib {
  height: 60vh;
}

.containerYt {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.contentYt {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: #f1f1f1;
  padding: 5px 10px 0 10px;
}

.itemYt {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  height: 80px;
  gap: 20px;
  border: 1px solid rgb(227, 227, 227);
  border-radius: 8px;
}

.imgYt {
  width: 45px;
  height: 25px;
}

.descriptionYt {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.contentLogosocialMedia {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
}

.socialMedia {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
}

.numberMessages {
  width: 18px;
  height: 18px;
  position: absolute;
  top: -4px;
  right: -5px;
  background-color: red;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.357);
}

p {
  margin: 0 !important;
}

.warningExpiredPlan {
  position: absolute;
  top: -7px;
  right: -3px;
}

.contentBtnMyPlan {
  position: relative;
}

.warningExpiredPlanToModal {
  position: absolute;
  right: 60px;
}

.containerMobile {
  display: none;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .sidebar .nav-links li {
    height: 35px;
  }

  .sidebar {
    justify-content: start;
  }

  .disable {
    width: 50px;
  }

  .contentLogoAndTitle {
    gap: 30px;
    font-size: 20px;
  }

  .nameCompany {
    font-size: 14px;
  }

  .contentNotificationAccounting {
    font-size: 11px;
  }

  .contentHelpAndNotificationAccounting {
    gap: 1rem;
  }

  .contentHelp {
    padding: 0px;
  }
}

@media screen and (max-width: 700px) {
  .navBar {
    display: none;
  }

  .sidebar {
    display: none;
  }

  .containerMobile {
    display: flex;
    position: absolute;
    right: 20px;
    top: 20px;
    border: none;
  }

  .opticoMobile {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 15px;
    background: #f4f4f4;
    padding: 5px 15px;
    color: rgb(54, 54, 54);
    top: 20px;
    border: 1px solid #c3c3c3;
    border-radius: 10px;
  }

  .sideMobile {
    display: flex;
    position: absolute;
    right: 0;
    top: 80px;
  }

  .sidebarMobile {
    position: fixed !important;
    z-index: 1000;
    top: 55px;
    right: 20px;
    height: 100vh;
    max-height: calc(100vh - 80px);
    width: 80vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #3a4750ed;
    border-radius: 10px;
    transition: all 0.5s ease;
    overflow-y: overlay;
    overflow-x: hidden;
  }

  .disableMobile {
    position: fixed !important;
    z-index: 1000;
    top: 50px;
    height: calc(100vh - 50px);
    width: 0px;
    visibility: hidden;
    background: #0188c8;
    transition: all 0.5s ease;
  }

  .sidebarMobile .nav-links li {
    height: 40px;
    width: 100%;
    list-style: none;
  }

  .sidebarMobile .nav-links li .contentLink {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    text-decoration: none;
    transition: all 0.4s ease;
  }

  .sidebarMobile .nav-links li .contentLink:hover {
    background: #768593b5;
  }

  .sidebarMobile .nav-links li .contentLink i {
    min-width: 55px;
    text-align: center;
    color: #fff;
    font-size: 1rem;
  }

  .sidebarMobile .nav-links li .contentLink .link_name {
    color: #fff;
    font-size: 1rem;
    transition: all 0.4s ease;
  }

  .sidebarMobile .nav-links li .contentLink .droperText {
    color: #fff;
    font-size: 1rem;
    transition: all 0.4s ease;
  }
}
</style>